
    export const CategoryButtonStyles = {
        minWidth: "150px",
        minHeight: "45px",
        maxWidth: "150px",
        maxHeight: "45px",
        margin: "10px"
    }
